import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ToastrService} from "ngx-toastr";
import {ReferencesService} from "../../references.services";

@Component({
  selector: 'app-add-eit-golden-rule-dialog',
  templateUrl: './add-edit-golden-rule-dialog.component.html',
  styleUrls: ['./add-edit-golden-rule-dialog.component.scss']
})
export class AddEditGoldenRuleDialogComponent implements OnInit {

  ruleData: any = {rule: ''};
  dialogTitle: string = 'Add';

  constructor(public dialogRef: MatDialogRef<AddEditGoldenRuleDialogComponent>,
              private toaster: ToastrService,
              public referencesService: ReferencesService,
              @Inject(MAT_DIALOG_DATA) public data?: any) {
    if (!data || (data && !data._id)) {
      data = {_id: null, rule: null};
    }
    this.ruleData = data;
    this.dialogTitle = !data._id ? 'Add' : 'Edit';
  }

  ngOnInit(): void {
  }

  onDialogClose(isSave) {
    if (isSave) {
      if (!this.ruleData.rule) {
        this.toaster.warning("Rule should not be null. If you want to delete it, Please use delete icon.")
        return;
      } else {
        if (this.ruleData._id) {
          this.referencesService.editReference({
            "rule": this.ruleData.rule,
            "_id": this.ruleData._id
          }).subscribe((result: any) => {
            this.dialogRef.close(true);
          }, error => {
            this.toaster.error('Unable to save the rule, Please try again.');
            return;
          });
        } else {
          // Add a new rule
          this.referencesService.saveGoldenRuleOrLinks({
            rule: this.ruleData.rule,
            name: 'goldenRule' + Date.now()
          }, 'goldenRule').subscribe((result: any) => {
            this.dialogRef.close(true);
          }, error => {
            this.toaster.error('Unable to save the rule, Please try again.');
            return;
          });
        }
      }
    } else {
      this.dialogRef.close(false);
    }

  }

}
